<template>
  <div class="container">
    <div class="m-portrait">
      <div @click="toSite('userDetails')">
        <div class="m-left">
          <img class="m-photo" src="../../../public/images/personal/grzx-00.png">
          <div class="m-info-box">
            <p class="m-name">{{userData.callName}}</p>
            <p class="m-class">{{userData.mobilePhone}}</p>
          </div>
        </div>
        <div class="m-right"><i class="icon icon-arrow-right"></i></div>
      </div>

    </div>
    <div class="m-chunk row row-space-between">
      <div class="col-auto">
        <div class="m-img-box one-bg" @click="$router.push({name: 'questionRecordList'})">
          <img class="m-img" src="../../../public/images/personal/grzx-50.png">
        </div>
        <p>问诊记录</p>
      </div>
      <!--<div class="col-4">-->
      <!--<div class="m-img-box two-bg" @click="$router.push({name: 'medicalCardList'})">-->
      <!--<img class="m-img" src="../../../public/images/personal/grzx-10.png">-->
      <!--</div>-->
      <!--<p>我的体检卡</p>-->
      <!--</div>-->
      <div class="col-auto">
        <div class="m-img-box two-bg" @click="$router.push({name: 'cardList'})">
          <img class="m-img" src="../../../public/images/personal/grzx-52.png">
        </div>
        <p class="fitness">我的健康卡
          <span class="fitnessNumber" v-show="tabStats && tabStats.healthtCard && tabStats.healthtCard> 0">{{tabStats.healthtCard}}张</span>
        </p>

      </div>
      <div class="col-auto">
        <div class="m-img-box three-bg" @click="toSite('team')">
          <img class="m-img" src="../../../public/images/personal/grzx-51.png">
        </div>
        <p>我的团检单</p>
      </div>
    </div>
    <div class="flex-between row text-left box-center " >
      <div class="row flex-between" @click="toSite('medicalCardList')">
        <div class="imgBox row flex-between"><img class="m-img" src="../../../public/images/personal/grzx-54.png"> <span>体检卡</span></div>
        <div>
          <span class="assertive">{{tabStats.cardCount}}</span>张
        </div>

      </div>
      <div class="row flex-between" @click="toSite('electronicCouponList')">
        <div class="imgBox row flex-between"><img class="m-img" src="../../../public/images/personal/grzx-55.png"> <span>电子券</span></div>
        <div>
         <span class="assertive">{{tabStats.couponCount}}</span>张
        </div>
      </div>
    </div>
    <ul class="m-list">

      <li class="m-item row" @click="toSite('assess')">
        <div class="m-item-left">
          <img src="../../../public/images/personal/grzx-04.png">
        </div>
        <div class="m-item-right">
          <span>我的评估</span>
          <p><span>量表、疾病风险评估</span><i class="icon icon-arrow-right"></i></p>
        </div>
      </li>
    </ul>

    <ul class="m-list">
      <li class="m-item row" @click="toSite('purchaseRecord')">
        <div class="m-item-left">
          <img src="../../../public/images/personal/grzx-56.png">
        </div>
        <div class="m-item-right">
          <span>购买记录</span>
          <p><span>已购买的商品记录</span><i class="icon icon-arrow-right"></i></p>
        </div>
      </li>
      <li class="m-item row" @click="toSite('family')">
        <div class="m-item-left">
          <img src="../../../public/images/personal/grzx-53.png">
        </div>
        <div class="m-item-right">
          <span>家庭成员</span>
          <p><span></span><i class="icon icon-arrow-right"></i></p>
        </div>
      </li>
      <!--<li class="m-item row" @click="toSite('healthFund')">-->
        <!--<div class="m-item-left">-->
          <!--<img src="../../../public/images/personal/grzx-06.png">-->
        <!--</div>-->
        <!--<div class="m-item-right">-->
          <!--<span>电子券</span>-->
          <!--<p><span></span><i class="icon icon-arrow-right"></i></p>-->
        <!--</div>-->
      <!--</li>-->
    </ul>

    <ul class="m-list" @click="toSite('aboutUs')">
      <li class="m-item row">
        <div class="m-item-left">
          <img src="../../../public/images/personal/grzx-05.png">
        </div>
        <div class="m-item-right">
          <span>关于我们</span>
          <p><span></span><i class="icon icon-arrow-right"></i></p>
        </div>
      </li>
    </ul>

    <div class="m-quit">
      <button class="m-btn" @click.stop="logoutClicked">退出账号</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Location } from '@/assets/scripts/helper'
import { Toast } from 'vant'
import { wxOAuth } from '@/assets/scripts/wechat'
import { PERSONAL_TAB_STATS } from '@/assets/scripts/api'
import Vue from 'vue'
import { Loading } from '../../assets/scripts/helper/index'
import Cookies from 'js-cookie'
Vue.use(Toast)

export default {
  data () {
    return {
      tabStats: {},
      site: {
        userDetails: 'personageDetail',
        electronicCouponList: 'electronicCouponList',
        medicalCardList: 'medicalCardList',
        team: 'order',
        purchaseRecord: 'purchaseRecordList',
        assess: '/wx/index.html#/topic/record',
        family: 'familyList',
        healthFund: '/wx/index.html#/coupon/list',
        aboutUs: this.$store.state.sid === '00-0' ? 'https://mp.weixin.qq.com/s?__biz=MzAwNTEwNDE4NA==&mid=202753268&idx=1&sn=54f82150af4fadbc085c7ba39a3f58b6&scene=5#rd' : 'mecPersonalCenter'
      },
      name: '个人中心'
    }
  },
  methods: {
    async logoutClicked () {
      this.$store.dispatch('user/clearUserData')
      if (window.WeixinJSBridge && typeof window.WeixinJSBridge.call === 'function') {
        window.WeixinJSBridge.call('closeWindow')
      } else {
        this.$router.push('/')
      }
      //
    },
    topTab (i) {
      i === '1' ? Location(`/wx/index.html?sid=${this.$store.state.sid}#/questionnaire/customize`, false) : Toast.fail('正在开发中')
    },
    toSite (name) {
      if (/\//g.test(this.site[name])) {
        Location(this.site[name], false)
      } else {
        this.site[name] === 'order' ? this.$router.push({
          name: this.site[name],
          query: {type: 2}
        }) : this.$router.push({name: this.site[name]})
      }
    }
  },
  async created () {
    if (this.loads) {
      Loading.show()
      //   console.log(this.userData)
      let {data} = await this.$axios.get(PERSONAL_TAB_STATS, {params: {sysCenterId: this.$store.state.sid === '00-0' ? '' : this.$store.state.sid }})
      Loading.close()
      this.tabStats = data
      let params = this.$route.fullPath.split('?')[1]
      if (this.$route.query.exits && params.split('&').length === 1) {
        Location(wxOAuth(this.$store.state.wxContentUrl + '/index.html?sid=' + this.$store.state.initializeSid + '#/login?uri=' + encodeURIComponent(this.$store.state.webContentUrl + this.$route.fullPath.split('?')[0])), true)
      } else if (this.$route.query.exits) {
        let toOld = ''
        params.split('&').forEach(obj => {
          if (obj.indexOf('exits') === -1) {
            toOld += toOld ? '&' + obj : obj
          }
        })
        toOld = '?' + toOld
        Location(wxOAuth(this.$store.state.wxContentUrl + '/index.html?sid=' + this.$store.state.initializeSid + '#/login?uri=' + encodeURIComponent(this.$store.state.webContentUrl + this.$route.fullPath.split('?')[0] + toOld)), true)
      }
    }
  },
  mounted () {
    this.$store.dispatch('user/getUserData')
  },
  computed: {
    loads () {
      return Cookies.get('51jk.TK')
    },
    ...mapGetters({userData: 'user/getSelf'})
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";

  .m-portrait {
    width: 100%;
    padding: 10px 15px;
    overflow: hidden;
    background-color: $light;
    .m-left {
      display: inline-block;
    }
    .m-photo {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      border: 1px solid #dddddd;
      vertical-align: middle;
    }
    .m-info-box {
      position: relative;
      display: inline-block;
      height: 60px;
      padding-left: 10px;
      vertical-align: top;
      .m-name {
        line-height: 40px;
        font-size: 16px;
        /*font-weight: bold;*/
        .m-img {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          vertical-align: sub;
        }
      }
      .m-class {
        font-size: 14px;
        color: #999;
      }
      .m-teach {
        line-height: 60px;
        font-size: 20px;
      }
    }
    .m-right {
      float: right;
      height: 60px;
      line-height: 60px;
    }
  }

  .m-chunk {
    background: $light;
    text-align: center;
    margin-top: 7px;
    padding: 15px ;
    .m-img-box {
      width: 80px;
      text-align: center;
      .m-img {
        /*margin-left: 10px;*/
          width: 60px;
      }
    }

    p {
      line-height: 24px;
      font-size: 14px;
    }
  }

  .fitness {

    position: relative;
    .fitnessNumber {
      font-size: 12px;
      position: absolute;
      background: $assertive;
      color: $light;
      right: -8px;
      top: -20px;
      padding: 3px 5px;
      line-height: 1;
      z-index: 2;
      &:before {
        z-index: -1;
        content: '';
        display: inline-block;
        position: absolute;
        width: 0;
        border: solid transparent;
        border-width: 0px 10px 8px 16px;
        /*<!--border-top-color: $assertive;-->*/
        /*border-left-color: green;*/
        border-bottom-color: $assertive;
        /*border-right-color: yellow;*/
        top: 12px;
        left: -2px;
        /*<!--transform: transLateX(-50%);-->*/
        /*transform: translateY(90deg)*/
        transform: rotate(-35deg);
        /*left: 2px;*/
        /*top: 15px;*/
      }
    }
  }

  .box-center {
    padding:  7px 0 0 0;
    > div {
      align-items: center;
      padding: 15px 10px;
      &:last-child {
        border-radius: 8px 0 0 8px;
        margin-left: 15px;
      }
      &:first-child {
        border-radius: 0 8px 8px 0;
      }
      flex: 1;
      background: $light;
    }
    .imgBox {
      /*vertical-align: middle;*/
      align-items: center;
      img{
        width: 30px;
        margin-right: 5px;
        /*vertical-align: middle;*/
      }
    }
    /*vertical-align: center;*/
    /*img{*/
    /*vertical-align: center;*/
    /*}*/

  }

  .m-list {
    margin-top: 10px;
    padding: 0 15px;
    background-color: #ffffff;
    .m-item {
      width: 100%;
      height: 50px;
      line-height: 50px;
      .m-item-left {
        position: relative;
        display: flex;
        width: 44px;
        > img {
          position: absolute;
          width: 20px;
          top: 0;
          left: 0;
          right: 10px;
          bottom: 0;
          margin: auto;
        }
      }
      .m-item-right {
        display: flex;
        flex: 1;
        justify-content: space-between;
        border-bottom: 1px solid $grey;
        > span {
          font-size: 14px;
        }
        > P {
          display: inline-flex;
          font-size: 12px;
          line-height: 50px;
          > span {
            padding-right: 5px;
            color: $dark09;
          }
        }
        .icon{
          color: $dark09;
        }

      }
    }
  }

  .m-quit {
    margin-top: 30px;
    text-align: center;
    .m-btn {
      width: 90%;
      height: 44px;
      border-radius: 4px;
      border: none;
      /*<!--border: 1px solid $assertive;-->*/
      letter-spacing: 1px;
      background-color: $assertive;
      font-size: 15px;
      color: $light;
    }
  }
</style>
